import { createEntityAdapter, createSelector, createSlice, Dictionary, PayloadAction, Update } from '@reduxjs/toolkit';
import { WebsiteState } from '../store';
import { Json } from '@gift/types/Json';
import { bindInputSelectorFactory, bindInputUpdaterFactory } from '@gift/common/helpers/pluginBindings';

const adapter = createEntityAdapter<Json.Input<any>>();
const adapterSelectors = adapter.getSelectors<WebsiteState>(s => s.inputs);

export const { actions, reducer } = createSlice({

    name: 'inputs',
    initialState: adapter.getInitialState(),

    reducers: {

        setAll: adapter.setAll,

        updateMany: (state, action: PayloadAction<readonly Update<Json.Input<any>>[]>) => {
            for (const update of action.payload) {
                const input = state.entities[update.id];
                if (input) {
                    input.value = {
                        ...input.value,
                        ...update.changes
                    };
                }
            }
        },

        upsertMany: (state, action: PayloadAction<readonly Json.Input<any>[]>) => {
            for (const update of action.payload) {
                const input = state.entities[update.id];
                if (input) {
                    input.value = { ...input.value, ...update.value };
                } else {
                    state.ids.push(update.id);
                    state.entities[update.id] = update;
                }
            }
        }
    }
});

export const selectActiveInputs = createSelector([
    (state: WebsiteState) => state.variables.ids,
    (state: WebsiteState) => state.inputs.entities,
], (activeIds, savedInputs) => {
    const activeInputs: Dictionary<Json.Input<any>> = {};
    activeIds.forEach(id => activeInputs[id] = savedInputs[id]!);
    return activeInputs;
});

export const createInputBindings = <TInput>() => ({
    createInputSelector: bindInputSelectorFactory(adapterSelectors).to<TInput>(),
    createInputUpdater: bindInputUpdaterFactory(actions.updateMany).to<TInput>(),
});